const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Manga%20review%20video%20thumbnail%20style%2C%20colorful%20comic%20panels%20collage%2C%20warm%20orange%20and%20coral%20tones%2C%20dynamic%20layout%20with%20manga%20characters%2C%20YouTube%20style%20review%20thumbnail%2C%20energetic%20atmosphere&width=800&height=450&seq=media-manga-01&orientation=landscape',
    title: '2026上半年必看韩漫TOP10大盘点',
    desc: '一口气盘点今年最值得追的韩漫佳作，从恋爱到奇幻全都有！',
    views: '32.6万',
    duration: '15:28',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comic%20review%20thumbnail%20style%2C%20manga%20page%20comparison%20with%20anime%20scene%2C%20warm%20amber%20tones%2C%20split%20screen%20layout%2C%20anime%20manga%20comparison%20style%2C%20clean%20modern%20design&width=800&height=450&seq=media-manga-02&orientation=landscape',
    title: '日漫原作vs动画改编：哪些改编超越了原作？',
    desc: '盘点那些动画化后口碑炸裂的日漫作品，聊聊改编的成功秘诀。',
    views: '28.1万',
    duration: '22:14',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Manga%20recommendation%20thumbnail%2C%20Chinese%20manhua%20art%20style%20showcase%2C%20warm%20coral%20and%20cream%20tones%2C%20multiple%20cover%20art%20collage%2C%20recommendation%20list%20style&width=800&height=450&seq=media-manga-03&orientation=landscape',
    title: '那些被低估的国漫神作，每一部都值得看',
    desc: '不是大IP却口碑极佳！这些国漫佳作你不应该错过。',
    views: '19.7万',
    duration: '18:42',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=New%20manga%20preview%20thumbnail%20style%2C%20fresh%20manga%20cover%20art%20showcase%2C%20warm%20orange%20and%20amber%20tones%2C%20upcoming%20releases%20collage%2C%20anticipation%20vibe&width=800&height=450&seq=media-manga-04&orientation=landscape',
    title: '七月新作抢先看：本月最值得期待的新漫画',
    desc: '又一批新作上线！为你精选本月最值得入坑的新漫画连载。',
    views: '24.3万',
    duration: '12:56',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            漫评精选
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            漫画点评与推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            资深漫迷为你带来最走心的漫画点评与推荐指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-white text-[10px] font-medium backdrop-blur-sm">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1.5 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 mt-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}